import { buildGetPagesQuery } from '@/common/utils/prepareSignature'
import { CerteuropeSignState } from "@/store/modules/certeurope-sign/state";

import { CerteuropeSignActionTypes } from './action_types'
import { CerteuropeSignMutationTypes } from './mutation_types'
import certEuropeSignService from '../../../services/certeurope-sign.service'
import prepareSignatureService from '../../../services/prepareSignature.service'

export const actions: StoreActions<CerteuropeSignActionTypes, CerteuropeSignMutationTypes> = {
  async [CerteuropeSignActionTypes.CONFIRM_SIGNATURE] ({ commit }, { mnemo, envelopeId }) {
    commit(CerteuropeSignMutationTypes.SET_CONFIRM_SIGNATURE_PENDING, true)
    try {
      await certEuropeSignService.confirmSignature(mnemo, envelopeId)
    } catch (error) {
      commit(CerteuropeSignMutationTypes.SET_CONFIRM_SIGNATURE_ERROR, error)
      throw error
    } finally {
      commit(CerteuropeSignMutationTypes.SET_CONFIRM_SIGNATURE_PENDING, false)
    }
  },
  async [CerteuropeSignActionTypes.RESEND_VALIDATION_SMS] ({ commit }, { mnemo, envelopeId }) {
    commit(CerteuropeSignMutationTypes.SET_RESEND_VALIDATION_SMS_PENDING, true)
    try {
      await certEuropeSignService.resentValidationSms(mnemo, envelopeId)
    } catch (error) {
      commit(CerteuropeSignMutationTypes.SET_RESEND_VALIDATION_SMS_ERROR, error)
      throw error
    } finally {
      commit(CerteuropeSignMutationTypes.SET_RESEND_VALIDATION_SMS_PENDING, false)
    }
  },
  async [CerteuropeSignActionTypes.SIGN_DOCUMENT] ({ commit }, { mnemo, envelopeId, data }) {
    commit(CerteuropeSignMutationTypes.SET_SIGN_DOCUMENT_PENDING, true)
    try {
      await certEuropeSignService.signDocument(mnemo, envelopeId, data)
    } catch (error) {
      commit(CerteuropeSignMutationTypes.SET_SIGN_DOCUMENT_ERROR, error)
      throw error
    } finally {
      commit(CerteuropeSignMutationTypes.SET_SIGN_DOCUMENT_PENDING, false)
    }
  },
  async [CerteuropeSignActionTypes.SEND_VALIDATION_SMS] ({ commit }, { mnemo, envelopeId, data }) {
    commit(CerteuropeSignMutationTypes.SET_SEND_VALIDATION_SMS_PENDING, true)
    try {
      await certEuropeSignService.sentValidationSms(mnemo, envelopeId, data)
    } catch (error) {
      commit(CerteuropeSignMutationTypes.SET_SEND_VALIDATION_SMS_ERROR, error)
      throw error
    } finally {
      commit(CerteuropeSignMutationTypes.SET_SEND_VALIDATION_SMS_PENDING, false)
    }
  },
  async [CerteuropeSignActionTypes.UNSIGN_TAG] ({ commit, state }, { mnemo, envelopeId, tagId, page }) {
    commit(CerteuropeSignMutationTypes.SET_UNSIGN_TAG_PENDING, tagId)
    try {
      const response = await certEuropeSignService.unsignTag(mnemo, envelopeId, tagId)
      commit(CerteuropeSignMutationTypes.REFRESH_TAG, { page, tag: response.data.tag })
    } catch (error) {
      commit(CerteuropeSignMutationTypes.SET_UNSIGN_TAG_ERROR, error)
      throw error
    } finally {
      commit(CerteuropeSignMutationTypes.REMOVE_UNSIGN_TAG_PENDING,
        (state as CerteuropeSignState).unsignTagPendingIds.indexOf(tagId))
    }
  },
  async [CerteuropeSignActionTypes.SIGN_TAG] ({ commit, state }, { mnemo, envelopeId, tagId, data, page }) {
    commit(CerteuropeSignMutationTypes.SET_SIGN_TAG_PENDING, tagId)
    try {
      const response = await certEuropeSignService.signTag(mnemo, envelopeId, tagId, data)
      commit(CerteuropeSignMutationTypes.REFRESH_TAG, { page, tag: response.data.tag })
    } catch (error) {
      commit(CerteuropeSignMutationTypes.SET_SIGN_TAG_ERROR, error)
      throw error
    } finally {
      commit(CerteuropeSignMutationTypes.REMOVE_SIGN_TAG_PENDING,
        (state as CerteuropeSignState).signTagPendingIds.indexOf(tagId))
    }
  },
  async [CerteuropeSignActionTypes.GET_PAGES] ({ commit, state }, { mnemo, envId, fromPage, toPage }) {
    for (let i = fromPage; i <= toPage; i++) {
      if (!(state as CerteuropeSignState).pagesNumberPending.includes(i)) {
        commit(CerteuropeSignMutationTypes.ADD_PAGES_NUMBER_PENDING, { fromPage: i, toPage: i })
        try {
          const response = await prepareSignatureService.getPages(mnemo, envId, buildGetPagesQuery({ fromPage: i, toPage: i }))
          commit(CerteuropeSignMutationTypes.SET_PAGES, response.data)
        } catch (error) {
          commit(CerteuropeSignMutationTypes.SET_PAGES_ERROR, error)
          throw error
        } finally {
          commit(CerteuropeSignMutationTypes.REMOVE_PAGES_NUMBER_PENDING, { fromPage: i, toPage: i })
        }
      }
    }
  },
  async [CerteuropeSignActionTypes.GET_SIGNING_VIEW] ({ commit }, { mnemo, envelopeId }) {
    commit(CerteuropeSignMutationTypes.SET_SIGNING_VIEW_PENDING, true)
    commit(CerteuropeSignMutationTypes.SET_SIGNING_VIEW_ERROR, null)
    try {
      const response = await certEuropeSignService.getSigningView(mnemo, envelopeId)
      commit(CerteuropeSignMutationTypes.SET_SIGNING_VIEW, response.data)
    } catch (error) {
      commit(CerteuropeSignMutationTypes.SET_SIGNING_VIEW_ERROR, error)
      throw error
    } finally {
      commit(CerteuropeSignMutationTypes.SET_SIGNING_VIEW_PENDING, false)
    }
  },
}
